import { ThemeProvider } from "@emotion/react";
import { theme } from "./theme";
import AppRouter from "./routes";
import "./muiLicense";
import SnackbarComponent from "./components/common/SnackbarComponent";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <AppRouter />
      <SnackbarComponent />
    </ThemeProvider>
  );
};

export default App;
